module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/piotr-zysik-4660c6a84f1ea54bf95ca74a1b665351.webp";